<template>
  <div class="sidebar-container" :class="{ closeMenu: collapsed, 'mobile-navigation': mobile }">
    <router-link to="/dashboard" class="logo-container" aria-label="داشبورد وینو">
      <img v-if="collapsed" :src="mark" alt="وینو" class="logo-mark" />
      <img v-else :src="logo" alt="وینو" class="logo-full" />
    </router-link>
    <nav class="menu-item-container" aria-label="بخش‌های مدیریت">
      <div v-if="loading" class="menu-skeleton" role="status" aria-label="در حال دریافت منو"><span v-for="index in 6" :key="index"></span></div>
      <div v-else-if="failed" class="menu-message"><p v-if="!collapsed">دریافت منو انجام نشد.</p><button type="button" @click="getMenuList" aria-label="دریافت دوباره منو">تلاش مجدد</button></div>
      <ul v-else class="navigation" :class="{ 'collapsed-navigation': collapsed }">
        <MenuItem v-for="menu in menuList" :key="menu.id" :menu="menu" :collapsed="collapsed" :open-id="openId" @expand="expand" @open="openId = $event" />
      </ul>
    </nav>
    <div class="sidebar-footer">
      <span class="footer-bars" aria-hidden="true"><i></i><i></i><i></i></span>
      <div v-if="!collapsed"><strong>وینو</strong><span>ساخت، اجرا و پایش پروژه‌های میدانی</span></div>
    </div>
  </div>
</template>
<script>
import MenuItem from './MenuItem.vue';
import { isTabGroup, menuContainsRoute, normalizeMenu } from '../../utils/adminNavigation';
export default {
  components: { MenuItem },
  props: { mobile: Boolean },
  data() { return { menuList: [], loading: true, failed: false, openId: null }; },
  computed: {
    collapsed() { return !this.mobile && this.$STORE.state.appConfig.closeMenu; },
    projectId() { return this.$STORE.state.userConfig.setProjectId; },
    logo() { return this.$PATH.GET_IMAGE_PATH('brand/vino-logo-light.svg'); },
    mark() { return this.$PATH.GET_IMAGE_PATH('brand/vino-mark.svg'); },
  },
  watch: { projectId() { this.getMenuList(); }, $route() { this.syncOpen(); } },
  created() { this.getMenuList(); },
  methods: {
    expand() { this.$STORE.commit('appConfig/changeMenuStatus', false); },
    // Opening a page opens only the group that contains it (tab groups are plain links).
    syncOpen() {
      const current = this.menuList.find((menu) => !isTabGroup(menu) && menu.children.length && menuContainsRoute(menu, this.$route.path));
      if (current) this.openId = current.id;
    },
    async getMenuList() {
      this.loading = true;
      this.failed = false;
      try {
        const res = await this.$ApiServiceLayer.get(this.$PATH.RELATIVE_PATH.GET.MENU_LIST + '?p=' + this.projectId + '&is_active=true', this.$PATH.SERVICE_NAME.AUTH);
        this.failed = res.status !== 200;
        this.menuList = this.failed ? [] : normalizeMenu(res.data);
        this.$STORE.commit('appConfig/setMenu', this.menuList);
        this.syncOpen();
      } finally { this.loading = false; }
    },
  },
};
</script>
<style scoped>
.sidebar-container { position: relative; width: 272px; height: 100vh; height: 100dvh; background: var(--shell-bg); color: var(--shell-text); display: flex; flex-direction: column; transition: width .25s var(--ease-out); border-left: 1px solid var(--shell-line); }
/* the analyst's graph paper, very faint */
.sidebar-container::before { content: ''; position: absolute; inset: 0; pointer-events: none; opacity: .5; background-image: linear-gradient(var(--shell-line) 1px, transparent 1px), linear-gradient(90deg, var(--shell-line) 1px, transparent 1px); background-size: 28px 28px; mask-image: linear-gradient(to bottom, #000, transparent 30%); -webkit-mask-image: linear-gradient(to bottom, #000, transparent 30%); }
.sidebar-container > * { position: relative; }
.sidebar-container.closeMenu { width: 84px; }
.logo-container { height: 76px; flex-shrink: 0; display: flex; align-items: center; justify-content: flex-start; padding: 18px 24px; border-bottom: 1px solid var(--shell-line); }
.logo-full { width: 118px; height: auto; }
.logo-mark { width: 40px; height: 40px; }
.closeMenu .logo-container { padding: 18px; justify-content: center; }
.menu-item-container { flex: 1; overflow-y: auto; padding: 14px 12px; scrollbar-color: var(--shell-raised) transparent; }
.navigation { padding: 0; margin: 0; }
.closeMenu .menu-item-container { padding: 14px 10px; }
.sidebar-footer { display: flex; gap: 12px; align-items: center; border-top: 1px solid var(--shell-line); margin: 0 18px; padding: 18px 0; }
.sidebar-footer strong, .sidebar-footer div > span { display: block; }
.sidebar-footer strong { font-size: 13px; font-weight: 900; }
.sidebar-footer div > span { font-size: 10.5px; color: var(--shell-text-3); margin-top: 2px; line-height: 1.6; }
.footer-bars { direction: ltr; display: flex; align-items: flex-end; gap: 3px; width: 36px; height: 36px; padding: 8px; flex-shrink: 0; border-radius: var(--r-sm); background: var(--shell-bg-2); box-shadow: inset 0 0 0 1px var(--shell-line); }
.footer-bars i { display: block; flex: 1; transform: skewX(var(--slant)); }
.footer-bars i:nth-child(1) { height: 100%; background: var(--teal-500); }
.footer-bars i:nth-child(2) { height: 70%; background: var(--pink-500); }
.footer-bars i:nth-child(3) { height: 40%; background: var(--amber-500); }
.closeMenu .sidebar-footer { margin: 0; justify-content: center; }
.menu-message { padding: 12px; color: var(--shell-text-2); font-size: 12px; }
.menu-message button { width: 100%; border: 1px solid var(--shell-line); border-radius: var(--r-xs); background: var(--shell-raised); color: #fff; min-height: 44px; font-weight: 700; }
.menu-skeleton span { display: block; height: 44px; border-radius: var(--r-sm); background: linear-gradient(90deg, var(--shell-bg-2), var(--shell-raised), var(--shell-bg-2)); background-size: 200% 100%; animation: shimmer 1.4s linear infinite; margin: 8px 0; }
@keyframes shimmer { to { background-position: -200% 0; } }
.mobile-navigation { width: 100%; height: auto; min-height: calc(100% - 48px); border: 0; }
</style>
